import { Injectable } from '@angular/core';
import type { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

interface MissingTranslationInterpolateParams {
  defaultValue?: string;
  skipMissingHandler?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MissingTranslationHandlerService implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const interpolateParams = params.interpolateParams as MissingTranslationInterpolateParams | undefined;
    if (interpolateParams?.skipMissingHandler) {
      return params.key;
    }

    let translatedValue: string;
    if (interpolateParams) {
      translatedValue = interpolateParams.defaultValue;
    }
    return translatedValue ?? params.key.split('.').pop() ?? params.key;
  }
}
